import React, { useEffect, useState } from "react";
import ProductCard from "../../../Hook/Pc"; // tu utilises le même composant
import "./Telephone.css";
import { useNavigate } from "react-router-dom";
const Telephone = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        fetch("https://www.amservices.eu/api/products-telephone.php")
            .then(res => res.json())
            .then(data => setProducts(Array.isArray(data) ? data : []))
            .catch(console.error);
    }, []);

    return (
        <>
            <h1 className="sr-only">Téléphones professionnels : configuration et maintenance</h1>
            <h2 className="section-title">Nos Téléphones</h2>

            <div className="product-list">
                {products.map(product => (
                    <div key={product.id} className="product-with-toggle Telephone">
                        <ProductCard
                            img={`https://www.amservices.eu/api/${product.logo}`}
                            alt={product.name}
                            title={product.name}
                            specs={[]}           // pas de specs pour les téléphones
                            optionText=""        // pas d'option pro
                            description={product.description}  // description directement dans la card
                        />
                    </div>
                ))}
            </div>
            <div className='div_btn-retour'>
                <div className="btn-telephones" onClick={() => navigate("/telephonie")}>
                    Retour
                </div>
            </div>
        </>
    );
};

export default Telephone;
